module.exports = __webpack_public_path__ + "media/images/product-img-02-0a030793627342f10dceed8d7b54b4fc.png";